export default "__VITE_ASSET__CdwUwtz7__"